import React from 'react';
import FactSheetPage1 from './FactSheetPage1';
import FactSheetPage2 from './FactSheetPage2';

const FactSheetViewer = ({ data, theme, chartRefs }) => {
  if (!data) return null;

  return (
    <div className="fact-sheet-viewer">
      <div className="report-pages">
        <FactSheetPage1 data={data} theme={theme} chartRefs={chartRefs} />
        <FactSheetPage2 data={data} theme={theme} chartRefs={chartRefs} />
      </div>
    </div>
  );
};

export default FactSheetViewer;
